import { api } from "./api";
import axios from "axios";

export const postUsuario = (usuario: any) =>
  api.post(`Usuario/incluir/`, usuario);
export const postFiltroUsuario = async (filtro: { [key: string]: string }, numeroPagina: string, registrosPorPagina: string, ordem: string) => {
  try {
    const response = await api.post(`Usuario/filtrar/${numeroPagina}/${registrosPorPagina}/${ordem}`, filtro);
    return response.data;
  } catch (error) {
    throw error;
  }
}
export async function getEnderecoByCEP(cep: string) {
  try {
    const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
    return response.data;
  } catch (error) {
    throw new Error("Erro ao buscar endereço pelo CEP");
  }
}
export const getMeusAnuncios = (cdUsuario: number, dmAtivo: boolean) =>
  api.get(`Usuario/buscar/meus-anuncios/${cdUsuario}/${dmAtivo}`);

export const getUsuario = (cdUsuario: number) =>
  api.get(`Usuario/buscar/${cdUsuario}`);

export const getTodosUsuarios = (cdUsuario: number) =>
  api.get(`Usuario/buscar/todosUsuarios/${cdUsuario}`);

export const getUsuarioDadoPublico = (cdUsuario: number) =>
  api.get(`Usuario/buscar/dados-publicos/${cdUsuario}`);

export const getUsuarios = async (numeroPagina: string, registrosPorPagina: string, ordem: string) => {
  try {
    const response = await api.get(`Usuario/buscartodos/${numeroPagina}/${registrosPorPagina}/${ordem}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const putUsuario = (usuario: any) => api.put(`Usuario/alterar/`, usuario);
export const putBloquearUsuario = (usuario: any) => api.put(`Usuario/bloquear`, usuario);
export const postEsqueceuSenha = (nmEmail: any) => {
  return api.post(`Usuario/esqueceu-senha`, nmEmail, {
    params: {
      email: nmEmail
    }
  });
}
export const postRedefinirSenha = (dadosRecuperacao: any) => api.post(`Usuario/resetar-senha`, dadosRecuperacao)

